import { combineReducers } from 'redux-immutable';

import menu from './menu.duck';

export default combineReducers({
  menu
});
